import { FunctionComponent, useEffect, useState } from 'react'
import { Alert, AlertProps, createTheme, Fade, Snackbar, SnackbarOrigin, Theme, ThemeProvider } from '@mui/material'
import styles from './notification.module.scss'
import { useScreenSize } from '@/modules/desktopMobile/screenSizeContext.tsx'

interface NotificationProps {
    severity: AlertProps['severity']
    message: string
    open: boolean
    setOpen: (open: boolean) => void
}

const Notification: FunctionComponent<NotificationProps> = ({
    severity,
    message,
    open,
    setOpen
}: NotificationProps) => {
    const [state, setState] = useState({
        open: false,
        Transition: Fade
    })

    useEffect(() => {
        setState({ ...state, open: open })
    }, [open])

    function handleClose(): void {
        setState({ ...state, open: false })
        setOpen(false)
    }

    const theme: Theme = createTheme({
        palette: {
            success: {
                main: '#4581bd'
            }
        }
    })

    const isMobile: boolean = useScreenSize()

    const anchorOrigin: SnackbarOrigin = isMobile
        ? { vertical: 'bottom', horizontal: 'center' }
        : { vertical: 'top', horizontal: 'right' }

    return (
        <ThemeProvider theme={theme}>
            <Snackbar
                open={state.open}
                onClose={handleClose}
                autoHideDuration={5000}
                anchorOrigin={anchorOrigin}
                className={isMobile ? styles.snackBarMobile : styles.snackBarWeb}
                slots={{ transition: state.Transition }}
            >
                <Alert onClose={handleClose} severity={severity} variant='filled' sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </ThemeProvider>
    )
}

export default Notification
